<div>
  <div class="delete-confirmation">
    <h2 class="dialog-title">{{ data.title || 'Delete' }}</h2>
    <p class="confirmation-line1">{{ data.message || 'Are you sure you want to delete this item?' }}</p>
  </div>
  <div class="button-container" *ngIf="!data.IsRemoveAction">
    <button class="button button-no" (click)="onCloseClick()">No</button>
    <button class="button button-yes" (click)="onConfirmDeleteClick()">{{ data.button1 || 'Yes' }}</button>
  </div>
  <div *ngIf="data.IsRemoveAction">
    <button class="button button-no" (click)="onCloseClick()">No</button>
    <button class="button button-warning" (click)="onConfirmDeleteClick()">{{ data.button1 || 'Yes' }}</button>
    <button class="button button-yes" (click)="onPermanentDeleteClick()">{{ data.button2 ||
      'Yes' }}</button>
  </div>
</div>